export enum RatesTypes {
  Taxes = 'taxesValue', // Monto total de los impuestos
  Total = 'total', // Monto Total del Precio. Amount + Fees + Taxes + Surcharges - DiscountAmount + PenaltyAmount
  Amount = 'amount', // Monto de la tarifa
  Fees = 'fees', // Monto de los fees ,
  Surcharges = 'surcharges', // Monto de los Surcharges ,
  DiscountAmount = 'discountAmount', // Monto total de los descuentos ,
  CommissionAmount = 'commissionAmount', // Monto total de la comisión ,
  CurrencyCode = 'currencyCode', // Código de moneda en la cual se encuentran los montos del objeto ,
  PenaltyAmount = 'penaltyAmount', // Field for exchanging penalties
  PaymentAgency = 'paymentAgency',
  TotalPayNow = 'totalPayNow',
  TotalPay = 'totalPay',
}

export const RATES_LABELS = {
  [RatesTypes.Taxes]: 'autosDetails.rates.labels.taxesValue',
  [RatesTypes.Amount]: 'autosDetails.rates.labels.amount',
  [RatesTypes.TotalPayNow]: 'autosDetails.rates.labels.totalPayNow',
  [RatesTypes.TotalPay]: 'autosDetails.rates.labels.totalPay',
  [RatesTypes.Total]: 'autosDetails.rates.labels.total',
  [RatesTypes.Fees]: 'autosDetails.rates.labels.fees',
  [RatesTypes.DiscountAmount]: 'autosDetails.rates.labels.discountAmount',
  [RatesTypes.PaymentAgency]: 'autosDetails.rates.labels.paymentAgency',
};

export const RATES_CLASSES = {
  [RatesTypes.DiscountAmount]: 'discount',
  [RatesTypes.Fees]: 'fees',
  [RatesTypes.Taxes]: 'taxes',
  [RatesTypes.PaymentAgency]: 'agency',
  [RatesTypes.Total]: 'total',
  [RatesTypes.TotalPayNow]: 'total-paynow',
  [RatesTypes.TotalPay]: 'total-pay',
};

export const RATES_ORDER = {
  [RatesTypes.Taxes]: 3,
  [RatesTypes.Amount]: 1,
  [RatesTypes.TotalPayNow]: 5,
  [RatesTypes.TotalPay]: 7,
  [RatesTypes.Total]: 7,
  [RatesTypes.Fees]: 4,
  [RatesTypes.DiscountAmount]: 2,
  [RatesTypes.PaymentAgency]: 6,
};

export const RATES_REQUIRED = {
  [RatesTypes.Taxes]: false,
  [RatesTypes.Amount]: true,
  [RatesTypes.TotalPayNow]: false,
  [RatesTypes.TotalPay]: false,
  [RatesTypes.Total]: true,
  [RatesTypes.Fees]: false,
  [RatesTypes.DiscountAmount]: false,
  [RatesTypes.PaymentAgency]: false,
};

export enum RatesSignalTypes {
  ADD = 'ADD',
  SUB = 'SUB',
  NONE = 'NONE',
  MULTIPLY = 'MULTIPLY',
}

export const RATES_SIGNAL = {
  [RatesTypes.Taxes]: RatesSignalTypes.ADD,
  [RatesTypes.Amount]: RatesSignalTypes.ADD,
  [RatesTypes.TotalPayNow]: RatesSignalTypes.NONE,
  [RatesTypes.TotalPay]: RatesSignalTypes.NONE,
  [RatesTypes.Total]: RatesSignalTypes.NONE,
  [RatesTypes.Fees]: RatesSignalTypes.ADD,
  [RatesTypes.DiscountAmount]: RatesSignalTypes.SUB,
  [RatesTypes.PaymentAgency]: RatesSignalTypes.MULTIPLY,
};

export interface RateUI {
  className: string;
  id: string;
  value: number | undefined;
  label: string;
  order: number;
  signal: RatesSignalTypes;
}
